/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Number/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Number({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder/Options/AddRelationship/Content/Phone/Fields/Number",
  isInvalid
  
}) {
let newRelationPhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'new_relation',
path: 'phone.number',
format: fromFormat.phoneNumberUS,
})
let newRelationPhoneNumberIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_relation',
path: 'phone.number',
validate: fromValidate.phoneNumber,
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isInvalid
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="new_relation.phone.number"
 format="/Data/format.js phoneNumberUS"
 validate="/Data/validate.js phoneNumber"
 invalid={!newRelationPhoneNumberIsValidData}
 value={newRelationPhoneNumberValueData}
 onChange={onChange}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Number"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="phone"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}